<template lang="html">
  <el-row class="tac">
    <el-col :span="24">
      <!-- <h5>默认颜色</h5> -->
      <el-menu
        :default-active="defaultActive"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        :collapse="false"
        background-color="#303133"
        text-color="#fff"
      >
        <router-link :to="{ name: 'ShowDetail' }">
          <el-menu-item index="ShowDetail">
            <i class="el-icon-data-line"></i>
            <span slot="title">概览</span>
          </el-menu-item>
        </router-link>
        <el-submenu index="finance">
          <template slot="title">
            <i class="el-icon-s-finance"></i>
            <span>财务</span>
          </template>
          <router-link :to="{ name: 'IncomeIndex' }">
            <el-menu-item index="IncomeIndex">
              <i class="el-icon-money"></i>
              <span slot="title">收入</span>
            </el-menu-item>
          </router-link>
          <!-- <router-link :to="{ name: 'Price' }">
            <el-menu-item index="Price">
              <i class="el-icon-price-tag"></i>
              <span slot="title">价格</span>
            </el-menu-item>
          </router-link> -->
          <!-- <router-link :to="{ name: 'Voucher' }">
            <el-menu-item index="Voucher">
              <i class="el-icon-discount"></i>
              <span slot="title">兑换券</span>
            </el-menu-item>
          </router-link> -->
          <el-submenu index="voucher">
            <template slot="title">
              <i class="el-icon-discount"></i>
              <span>兑换券</span>
            </template>
            <router-link :to="{ name: 'VoucherSetting' }">
              <el-menu-item index="VoucherSetting">
                <i class="el-icon-setting"></i>
                <span slot="title">设置</span>
              </el-menu-item>
            </router-link>
            <router-link :to="{ name: 'VoucherList' }">
              <el-menu-item index="VoucherList">
                <i class="el-icon-edit-outline"></i>
                <span slot="title">内容</span>
              </el-menu-item>
            </router-link>
          </el-submenu>
        </el-submenu>
        <el-submenu index="test">
          <template slot="title">
            <i class="el-icon-files"></i>
            <span>节目</span>
          </template>
          <router-link :to="{ name: 'EpisodeList' }">
            <el-menu-item index="EpisodeList">
              <i class="el-icon-document-copy"></i>
              <span slot="title">管理单集</span>
            </el-menu-item>
          </router-link>
          <router-link :to="{ name: 'CreateEpisode' }">
            <el-menu-item index="CreateEpisode">
              <i class="el-icon-document-add"></i>
              <span slot="title">创建新单集</span>
            </el-menu-item>
          </router-link>
        </el-submenu>
        <el-submenu index="website">
          <template slot="title">
            <i class="el-icon-mobile"></i>
            <span>网站</span>
          </template>
          <el-submenu index="notice">
            <template slot="title">
              <i class="el-icon-news"></i>
              <span>公告</span>
            </template>
            <router-link :to="{ name: 'NoticeSetting' }">
              <el-menu-item index="NoticeSetting">
                <i class="el-icon-setting"></i>
                <span slot="title">设置</span>
              </el-menu-item>
            </router-link>
            <router-link :to="{ name: 'NoticeList' }">
              <el-menu-item index="NoticeList">
                <i class="el-icon-edit-outline"></i>
                <span slot="title">内容</span>
              </el-menu-item>
            </router-link>
          </el-submenu>
          <router-link :to="{ name: 'Swiper' }">
            <el-menu-item index="Swiper">
              <i class="el-icon-reading"></i>
              <span slot="title">轮播</span>
            </el-menu-item>
          </router-link>
          <el-submenu index="topic">
            <template slot="title">
              <i class="el-icon-takeaway-box"></i>
              <span>专题</span>
            </template>
            <router-link :to="{ name: 'TopicSetting' }">
              <el-menu-item index="TopicSetting">
                <i class="el-icon-setting"></i>
                <span slot="title">设置</span>
              </el-menu-item>
            </router-link>
            <router-link :to="{ name: 'TopicList' }">
              <el-menu-item index="TopicList">
                <i class="el-icon-edit-outline"></i>
                <span slot="title">内容</span>
              </el-menu-item>
            </router-link>
          </el-submenu>

          <!-- <router-link :to="{ name: 'Topic' }">
            <el-menu-item index="Topic">
              <i class="el-icon-takeaway-box"></i>
              <span slot="title">专题</span>
            </el-menu-item>
          </router-link> -->

          <router-link :to="{ name: 'Recommend' }">
            <el-menu-item index="Recommend">
              <i class="el-icon-date"></i>
              <span slot="title">推荐</span>
            </el-menu-item>
          </router-link>
        </el-submenu>
        <el-menu-item index="4">
          <i class="el-icon-chat-line-square"></i>
          <span slot="title">评论</span>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>

  export default {
    data () {
      return {
        defaultActive: '',
        test: [],
        test1: {}
      }
    },
    watch: {
      '$route' (to, from) {
        window.console.log("$route发生变化")
        window.console.log(to)
        window.console.log(from)
        this.defaultActive = to.name
      }
    },
    methods: {
      handleOpen(key, keyPath) {
        window.console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        window.console.log(key, keyPath);
      }
    },
    mounted () {
      this.defaultActive = this.$route.name
    }
  }
</script>

<style lang="css" scoped>
  .el-menu {
    border: none;
  }
  .active {
    text-decoration: none;
  }
</style>
